import { usePkvPreviousInsuranceStore } from '@/features/Sparten/pkv/usePreviouseInsuranceInputStore';
import { TARIFF_SEARCH_REQUEST_IDENTIFIER } from '@/features/Tariffs/types';

export const pkvAlternateTariffSearchRequestIdentifier = () =>
  usePkvPreviousInsuranceStore().aktiv
    ? TARIFF_SEARCH_REQUEST_IDENTIFIER.ALL_TIME_TARIFF
    : undefined;
